import { render, staticRenderFns } from "./linediagramm.vue?vue&type=template&id=fa63f68c&scoped=true&"
import script from "./linediagramm.vue?vue&type=script&lang=js&"
export * from "./linediagramm.vue?vue&type=script&lang=js&"
import style0 from "./linediagramm.vue?vue&type=style&index=0&id=fa63f68c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa63f68c",
  null
  
)

export default component.exports